import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import AssetUploader from '../widgets/AssetUploader';
import AssetBrowser from '../widgets/AssetBrowser';
import { CATEGORIES } from '../../services/fileUpload/uploadFile';

import { checkPermissions } from '../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../constants/AccessPoints';

class PagesImages extends Component {
    constructor(props) {
        super(props);
    }

    onResetErrors = () => {
        this.browser && this.browser.resetErrors();
    };

    onRefresh = () => {
        this.browser && this.browser.refresh();
    };

    render() {
        return (
            <div className="ThemeCalendar Theme-Content">
                <h1>Images</h1>
                <p className="normal-text">Click on upload to upload an image</p>
                <AssetBrowser
                    setRef={node => (this.browser = node)}
                    category={CATEGORIES.IMAGE}
                    filter=".+\.(jpg|png|svg|jpeg|gif)$"
                    displayMode="grid"
                    hasAccessForDelete={this.props.hasAccessThemes.delete || this.props.hasAccessCustomContent.delete}
                >
                    <div className="col-xs-1">
                        <AssetUploader
                            onError={error => this.browser && this.browser.errorHandler(error)}
                            hasAccess={this.props.hasAccessThemes.add || this.props.hasAccessCustomContent.add}
                            filter=".+\.(jpg|png|svg|jpeg|gif)$"
                            metadata={{
                                category: CATEGORIES.IMAGE
                            }}
                            onResetErrors={this.onResetErrors}
                            onRefresh={this.onRefresh}
                            onOpen={this.onResetErrors}
                        />
                    </div>
                </AssetBrowser>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        hasAccessThemes: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        hasAccessCustomContent: checkPermissions(state, ACCESS_POINTS_GROUP.CUSTOM_CONTENT)
    };
};

PagesImages.propTypes = {
    children: PropTypes.element
};

export default connect(mapStateToProps)(PagesImages);



// WEBPACK FOOTER //
// ./src/components/assets/PagesImages.js